import { useEffect, useState } from "react";

import { adminApi, type SecurityCenterResponse } from "../api";
import { StatusTile } from "../components/StatusTile";

export function SecurityCenter(): JSX.Element {
  const [data, setData] = useState<SecurityCenterResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    adminApi
      .get<SecurityCenterResponse>("/api/v1/admin/security-center")
      .then(setData)
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
  }, []);

  return (
    <div>
      <h2 className="page-title">🔐 Security Center</h2>
      <p className="page-subtitle">Zero-trust / anomaly / device posture + open incidents.</p>
      {error && <div className="error-banner">{error}</div>}
      {data && (
        <>
          <div className="status-grid">
            <StatusTile status={data.status} />
          </div>
          <div className="kpi-row">
            <div className="kpi">
              <div className="value">{data.blocked_devices}</div>
              <div className="label">Blocked devices</div>
            </div>
            <div className="kpi">
              <div className="value">{data.quarantined_sessions}</div>
              <div className="label">Quarantined sessions</div>
            </div>
            <div className="kpi">
              <div className="value">{data.revoked_sessions}</div>
              <div className="label">Revoked sessions</div>
            </div>
          </div>
          <div className="panel">
            <h3>Open incidents</h3>
            <table>
              <thead>
                <tr>
                  <th>Source</th>
                  <th>Severity</th>
                  <th>Status</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                {data.open_incidents.map((i) => (
                  <tr key={i.id}>
                    <td>{i.source}</td>
                    <td>{i.severity}</td>
                    <td>{i.status}</td>
                    <td>{i.reason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
